/* eslint-disable jira/filename-case */
export const PACKAGE_NAME =
	'@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jira-business-project-menu';
export const TEAM_NAME = 'jira-cosmos';
